"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdManagerBase = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var utils_1 = require("@dp-instant/utils");
var AdManagerBase = (function (_super) {
    tslib_1.__extends(AdManagerBase, _super);
    function AdManagerBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdManagerBase.needToThrottleAd = function (conf) {
        var systemStart = conf.systemStart;
        var lastShow = conf.lastShow;
        var firstShow = systemStart + conf.showFirstDelay;
        var timeNow = Date.now();
        if (timeNow < firstShow) {
            utils_1.log.trace("needToThrottleAdd until " + (firstShow - timeNow));
            return true;
        }
        if (lastShow) {
            var nextShowTime = lastShow + conf.showNextDelay;
            if (timeNow < nextShowTime) {
                utils_1.log.trace("needToThrottleAdd until " + (nextShowTime - timeNow));
                return true;
            }
        }
        return false;
    };
    AdManagerBase.prototype.showAd = function (id, force, preloadNext) {
        if (force === void 0) { force = false; }
        if (preloadNext === void 0) { preloadNext = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, interfaces_1.AdResponse.NOT_SUPPORTED];
            });
        });
    };
    AdManagerBase.prototype.showRewardAd = function (id, preloadNext) {
        if (preloadNext === void 0) { preloadNext = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, interfaces_1.AdResponse.NOT_SUPPORTED];
            });
        });
    };
    AdManagerBase.prototype.preloadNextInter = function (placementID) {
        return tslib_1.__awaiter(this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2];
        }); });
    };
    AdManagerBase.prototype.preloadNextReward = function (placementID) {
        return tslib_1.__awaiter(this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2];
        }); });
    };
    AdManagerBase.prototype.onAdStarted = function (payload) {
        this.dispatch(interfaces_1.AdEvents.STARTED, payload);
    };
    AdManagerBase.prototype.onAdEnded = function (payload) {
        this.dispatch(interfaces_1.AdEvents.ENDED, payload);
    };
    AdManagerBase.config = {
        ids: {
            INTER: "",
            BANNER: "",
            REWARD: ""
        },
        throttling: {
            interstitial: {
                systemStart: Date.now(),
                showFirstDelay: 20 * 1000,
                showNextDelay: 60 * 1000,
                lastShow: 0
            }
        },
        interstitialsDisabled: false
    };
    return AdManagerBase;
}(core_1.GlobalEventProvider));
exports.AdManagerBase = AdManagerBase;
//# sourceMappingURL=AdManagerBase.js.map